// extracted by mini-css-extract-plugin
export default {"general":"General_general__D28xc","info":"General_info__1pSDG","donutContainer":"General_donutContainer__L3Hvj"};